var _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 66,
    viewBox: "0 0 481 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.5,
    cy: 33,
    rx: 240.5,
    ry: 33,
    fill: "#083A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseicon);
export default __webpack_public_path__ + "static/media/ellipse.icon.9d4acdc5b06c8863026efd771e02c986.svg";
export { ForwardRef as ReactComponent };